// extracted by mini-css-extract-plugin
export default {"wrapper":"hVJ97aUzqijchj22mD6V","content":"Md0v9xy40go9ZnuesZbX"};